/* replace these functions */

function rhumb(point1, point2, radius = 3440) {

    // see www.edwilliams.org/avform.htm#Rhumb

    const R = radius;
    const φ1 = point1.lat / 180.0 * Math.PI
    const φ2 = point2.lat / 180.0 * Math.PI
    const Δφ = φ2 - φ1;
    let Δλabs = Math.abs(point2.lon - point1.lon) / 180.0 * Math.PI;

    let Δλ = (point2.lon - point1.lon) / 180.0 * Math.PI;
    // if dLon over 180° take shorter rhumb line across the anti-meridian:
    if (Math.abs(Δλabs) > Math.PI) Δλabs = Δλabs > 0 ? -(2 * Math.PI - Δλabs) : (2 * Math.PI + Δλabs);

    // on Mercator projection, longitude distances shrink by latitude; q is the 'stretch factor'
    // q becomes ill-conditioned along E-W line (0/0); use empirical tolerance to avoid it
    const Δψ = Math.log(Math.tan(φ2 / 2 + Math.PI / 4) / Math.tan(φ1 / 2 + Math.PI / 4));
    const q = Math.abs(Δψ) > 10e-12 ? Δφ / Δψ : Math.cos(φ1);

    // distance is pythagoras on 'stretched' Mercator projection, √(Δφ² + q²·Δλ²)
    const δ = Math.sqrt(Δφ * Δφ + q * q * Δλabs * Δλabs); // angular distance in radians
    const d = δ * R;

    const θ = Math.atan2(Δλ, Δψ);

    const bearing = (θ / Math.PI * 180.0 + 360.0) % 360;

    return { d: d, b: bearing };
}


/*  end of replacements*/


const GRID_SPACING = 2.5;

class Vector {
    constructor(v) {
        if (v.length == 3) {
            this.v = v;
        }
    }
    dot(other) {
        return this.v[0] * other.v[0] + this.v[1] * other.v[1] + this.v[2] * other.v[2]
    }
    cross(other) {
        var res = [];
        res[0] = this.v[1] * other.v[2] - this.v[2] * other.v[1];
        res[1] = this.v[2] * other.v[0] - this.v[0] * other.v[2];
        res[2] = this.v[0] * other.v[1] - this.v[1] * other.v[0];
        return new Vector(res)
    }
    normalized() {
        if (this.length > 0) {
            return new Vector([this.v[0] / this.length, this.v[1] / this.length, this.v[2] / this.length])
        }
        else {
            return this;
        }
    }
    get length() {
        return Math.sqrt(this.v[0] * this.v[0] + this.v[1] * this.v[1] + this.v[2] * this.v[2])
    }
    toLatlon() {
        var lat = Math.atan2(this.v[2], Math.sqrt(this.v[0] * this.v[0] + this.v[1] * this.v[1]));
        var lon = Math.atan2(this.v[1], this.v[0]);
        return { lon: lon / Math.PI * 180.0, lat: lat / Math.PI * 180.0 }
    }
    scale(scale) {
        return new Vector([this.v[0] * scale, this.v[1] * scale, this.v[2] * scale]);
    }
    add(other) {
        return new Vector([this.v[0] + other.v[0], this.v[1] + other.v[1], this.v[2] + other.v[2]]);
    }
}

function lonlatToVector(lonlat) {
    var lon = lonlat.lon / 180.0 * Math.PI;
    var lat = lonlat.lat / 180.0 * Math.PI;
    return new Vector([
        Math.cos(lat) * Math.cos(lon),
        Math.cos(lat) * Math.sin(lon),
        Math.sin(lat)
    ]);
}


function lonsOnGreatCircle(Ncircle, lat) {
    var latRad = lat / 180.0 * Math.PI;
    var z = Math.sin(latRad);

    var A = 1 + Ncircle.v[0] * Ncircle.v[0] / (Ncircle.v[1] * Ncircle.v[1]);
    var B = 2 * Ncircle.v[0] * Ncircle.v[2] * z / (Ncircle.v[1] * Ncircle.v[1]);
    var C = (1 + Ncircle.v[2] * Ncircle.v[2] / (Ncircle.v[1] * Ncircle.v[1])) * z * z - 1;

    var D = B * B - 4 * A * C;

    if (D > 0.0) {
        var x1 = (-B + Math.sqrt(D)) / (2 * A);
        var x2 = (-B - Math.sqrt(D)) / (2 * A);
        var y1 = (-Ncircle.v[0] * x1 - Ncircle.v[2] * z) / Ncircle.v[1];
        var y2 = (-Ncircle.v[0] * x2 - Ncircle.v[2] * z) / Ncircle.v[1];

        var lon1 = Math.atan2(y1, x1)

        return { lon1: Math.atan2(y1, x1) / Math.PI * 180.0, lon2: Math.atan2(y2, x2) / Math.PI * 180.0 }
    }

}

import colorMap from "./ColorMap.js"
// import interpolateSavings from "./interpolateSavings"

export default function routeCalculator(waypoints, windData, performance, month, windRange, SFOCme, SFOCaux, shipSpeed) {
    var focMonthly = [
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
        {BL: 0, FRS: 0},
    ];
    var focYearly = {BL : 0, FRS : 0}
    
    
    if (!performance) {
        return {
            sections: [], 
            totalDistance: 0, 
            totalSavings: 0, 
            monthlySavings: 0, 
            focYearly: focYearly, 
            focMonthly: focMonthly
        };
    }
    var routeSections = [];
    var distCum = 0.000001
    var distMid = 0.0
    var totalSavings = 0.0
    // var montlySavings = [0,0,0,0,0,0,0,0,0,0,0,0]
    var focBLyearly = 0
    var focFRSyearly = 0
    var focBLmonthly = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    var focFRSmonthly = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    var cell;
    for (var i = 0; i < waypoints.length - 1; i++) {
        var wp0 = waypoints[i];
        var wp1 = waypoints[i + 1];
        var v0 = lonlatToVector(wp0);
        var v1 = lonlatToVector(wp1);

        var pointsSect = [wp0];

        var diffLon = ((wp1.lon - wp0.lon + 360) % 360);

        var dir = 1.0;

        var Ncircle = v0.cross(v1).normalized()

        var lat, lon, Nplane

        var minLat, maxLat

        if (diffLon < 180.0) {
            if (wp0.lon < wp1.lon) {
                for (lon = Math.ceil(wp0.lon / GRID_SPACING) * GRID_SPACING; lon < wp1.lon; lon += GRID_SPACING) {
                    Nplane = new Vector([Math.sin(lon / 180.0 * Math.PI), -Math.cos(lon / 180.0 * Math.PI), 0.0]);
                    pointsSect.push(Nplane.cross(Ncircle).scale(-1).toLatlon());
                }
                for (lat = -90.0 + GRID_SPACING; lat < 90.0; lat += GRID_SPACING) {
                    var lons = lonsOnGreatCircle(Ncircle, lat)
                    if (lons) {
                        if (lons.lon1 > wp0.lon && lons.lon1 < wp1.lon) {
                            pointsSect.push({ lon: lons.lon1, lat: lat });
                        }
                        if (lons.lon2 > wp0.lon && lons.lon2 < wp1.lon) {
                            pointsSect.push({ lon: lons.lon2, lat: lat });
                        }
                    }
                }

            }
            else if (wp0.lon !== wp1.lon) {
                for (lon = Math.ceil(wp0.lon / GRID_SPACING) * GRID_SPACING; lon < wp1.lon + 360; lon += GRID_SPACING) {
                    Nplane = new Vector([Math.sin(lon / 180.0 * Math.PI), -Math.cos(lon / 180.0 * Math.PI), 0.0])
                    pointsSect.push(Ncircle.cross(Nplane).toLatlon());
                }
                for (lat = -90.0 + GRID_SPACING; lat < 90.0; lat += GRID_SPACING) {
                    var lons = lonsOnGreatCircle(Ncircle, lat)
                    if (lons) {
                        if (lons.lon1 > wp0.lon || lons.lon1 < wp1.lon) {
                            pointsSect.push({ lon: lons.lon1, lat: lat });
                        }
                        if (lons.lon2 > wp0.lon || lons.lon2 < wp1.lon) {
                            pointsSect.push({ lon: lons.lon2, lat: lat });
                        }
                    }
                }
            }
            else {
                minLat = Math.min(wp0.lat, wp1.lat);
                maxLat = Math.max(wp0.lat, wp1.lat)
                for (lat = -90.0 + GRID_SPACING; lat < 90.0; lat += GRID_SPACING) {
                    if (lat > minLat && lat < maxLat) {
                        pointsSect.push({ lon: wp0.lon, lat: lat });
                    }
                }
            }
        }
        else {
            dir = -1.0;
            if (wp0.lon > wp1.lon) {
                for (lon = Math.floor(wp0.lon / GRID_SPACING) * GRID_SPACING; lon > wp1.lon; lon -= GRID_SPACING) {
                    Nplane = new Vector([Math.sin(lon / 180.0 * Math.PI), -Math.cos(lon / 180.0 * Math.PI), 0.0]);
                    pointsSect.push(Nplane.cross(Ncircle).toLatlon());
                }
                for (lat = -90.0 + GRID_SPACING; lat < 90.0; lat += GRID_SPACING) {
                    var lons = lonsOnGreatCircle(Ncircle, lat)
                    if (lons) {
                        if (lons.lon1 < wp0.lon && lons.lon1 > wp1.lon) {
                            pointsSect.push({ lon: lons.lon1, lat: lat });
                        }
                        if (lons.lon2 < wp0.lon && lons.lon2 > wp1.lon) {
                            pointsSect.push({ lon: lons.lon2, lat: lat });
                        }
                    }
                }
            }
            else if (wp0.lon !== wp1.lon) {
                for (lon = Math.floor(wp0.lon / GRID_SPACING) * GRID_SPACING; lon > wp1.lon - 360; lon -= GRID_SPACING) {
                    Nplane = new Vector([Math.sin(lon / 180.0 * Math.PI), -Math.cos(lon / 180.0 * Math.PI), 0.0])
                    pointsSect.push(Ncircle.cross(Nplane).scale(-1).toLatlon());
                }
                for (lat = -90.0 + GRID_SPACING; lat < 90.0; lat += GRID_SPACING) {
                    lons = lonsOnGreatCircle(Ncircle, lat)
                    if (lons) {
                        if (lons.lon1 < wp0.lon || lons.lon1 > wp1.lon) {
                            pointsSect.push({ lon: lons.lon1, lat: lat });
                        }
                        if (lons.lon2 < wp0.lon || lons.lon2 > wp1.lon) {
                            pointsSect.push({ lon: lons.lon2, lat: lat });
                        }
                    }
                }
            }
            else {
                minLat = Math.min(wp0.lat, wp1.lat);
                maxLat = Math.max(wp0.lat, wp1.lat)
                for (lat = -90.0 + GRID_SPACING; lat < 90.0; lat += GRID_SPACING) {
                    if (lat > minLat && lat < maxLat) {
                        pointsSect.push({ lon: wp0.lon, lat: lat });
                    }
                }
            }
        }

        pointsSect.push(wp1);
        if (dir > 0) {
            pointsSect.sort(function (a, b) { return ((a.lon - wp0.lon + 360) % 360) - ((b.lon - wp0.lon + 360) % 360) })
        }
        else {
            pointsSect.sort(function (a, b) { return ((b.lon - wp0.lon - 360) % 360) - ((a.lon - wp0.lon - 360) % 360) })
        }

        for (var j = 1; j < pointsSect.length; j++) {
            var p1 = pointsSect[j - 1];
            var p2 = pointsSect[j];
            var db = rhumb(p1, p2)
            db.d = Math.max(db.d,0.0000001);
            var from
            distMid = distCum + 0.5 * db.d;
            distCum += db.d;
            if (p1.lon == 180.0 && p2.lon < 0.0) {
                cell = Math.floor(0.5 * (-180 + p2.lon) / GRID_SPACING) + 72 + (Math.floor(0.5 * (p1.lat + p2.lat) / GRID_SPACING) + 36) * 144
                from = { lon: -180, lat: p1.lat }
                // routeSections.push({ from: { lon: -180, lat: p1.lat }, to: p2, c: rainbow(pointsSect.length - 1, j - 1), dist: db.d, bearing: db.b, distMid: distMid, distCum: distCum, cell:cell});
            }
            else if (p1.lon == -180.0 && p2.lon > 0.0) {
                cell = Math.floor(0.5 * (180 + p2.lon) / GRID_SPACING) + 72 + (Math.floor(0.5 * (p1.lat + p2.lat) / GRID_SPACING) + 36) * 144
                from = { lon: 180, lat: p1.lat }
                // routeSections.push({ from: { lon: 180, lat: p1.lat }, to: p2, c: rainbow(pointsSect.length - 1, j - 1), dist: db.d, bearing: db.b, distMid: distMid, distCum: distCum, cell:cell });
            }
            else {
                from = p1
                cell = Math.floor(0.5 * (p1.lon + p2.lon) / GRID_SPACING) + 72 + (Math.floor(0.5 * (p1.lat + p2.lat) / GRID_SPACING) + 36) * 144

            }
            var u = windData[2 * month * windRange + cell]
            var v = windData[(2 * month + 1) * windRange + cell]
            var trueWindSpeed = Math.sqrt(u * u + v * v)
            var trueWindDirection = (Math.atan2(u, v) / Math.PI * 180.0 - db.b + 900) % 360;

            var ii = Math.round(trueWindSpeed / 2);
            var ij = Math.round(trueWindDirection / 15) % 24;

            // var saving = interpolateSavings(1.0,trueWindSpeed,trueWindDirection,savings)


            var focBL = 0
            var focFRS = 0
            var s
            for (let im = 0; im < 12; im++) {
                let u = windData[2 * im * windRange + cell]
                let v = windData[(2 * im + 1) * windRange + cell]
                let trueWindSpeed = Math.sqrt(u * u + v * v)
                let trueWindDirection = (Math.atan2(u, v) / Math.PI * 180.0 - db.b + 900) % 360;

                let ii = Math.round(trueWindSpeed / 2);
                let ij = Math.round(trueWindDirection / 15) % 24;
                // debugger
                focBL = SFOCme(performance.power[ii][ij]) * performance.power[ii][ij] * db.d / shipSpeed
                focFRS = (SFOCme(performance.powerFlettner[ii][ij]) * performance.powerFlettner[ii][ij] + SFOCaux * performance.rotorPower[ii][ij]) * db.d / shipSpeed
                if (im === month) s = 1- focFRS/focBL
                focMonthly[im].BL += focBL / 1000000000
                focMonthly[im].FRS += focFRS / 1000000000
                focYearly.BL += focBL / 12 / 1000000000
                focYearly.FRS += focFRS / 12 / 1000000000
            }

            routeSections.push({
                from: from,
                to: p2,
                c: colorMap(s),
                dist: db.d,
                bearing: db.b,
                distMid: distMid,
                distCum: distCum,
                cell: cell,
                trueWindDirection: trueWindDirection,
                trueWindSpeed: trueWindSpeed,
                savings: s,
                wpPrev: i,
                wpNext: i + 1
            });
        }
        var monthlySavings = []
        for (let im = 0; im < 12; im++) {
            monthlySavings.push(1 - focFRSmonthly[im] / focBLmonthly[im])
        }
    }
    return { sections: routeSections, totalDistance: distCum, totalSavings: 1 - focYearly.FRS / focYearly.BL, monthlySavings: monthlySavings, focYearly: focYearly, focMonthly: focMonthly};
}